import ChargerModule from "./ChargerModule";

export default ChargerModule;
